<div class="row mb-2">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-1">
            <ng-content></ng-content>
        </ol>
        <mat-divider></mat-divider>
    </nav>
</div>
